import { pathBuilder } from 'config/paths/index';

export const root = '/inbox_v2';
export default pathBuilder(root);
